export const EVENT_TIMELINE_CELL = 'eventTimelineCell';
export const EVENT_TABLE_ROW = 'eventTableRow';
export const HEIGHT = 74;
